<common-header [title]="title" [items]="items"></common-header>

<app-list-locations [isABMReport]="false"> </app-list-locations>
